import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=2ceb3a76&scoped=true&lang=pug"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=2ceb3a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb3a76",
  null
  
)

export default component.exports